import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ContactInfo = ({ currentLanguage }) => {
  const contactDetails = {
    phone: '+254 721 320 787',
    whatsapp: '+254721320787',
    email: 'info@peterpartnerslaw.co.ke',
    address: {
      street: 'Westlands Business Centre, 2nd Floor',
      area: 'Westlands Road',
      city: 'Nairobi',
      country: 'Kenya',
      postalCode: '00100'
    },
    businessHours: {
      weekdays: '8:00 AM - 6:00 PM',
      saturday: '9:00 AM - 1:00 PM',
      sunday: 'Closed'
    }
  };

  const handlePhoneClick = () => {
    window.open(`tel:${contactDetails.phone}`, '_self');
  };

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(currentLanguage === 'en' ?'Hello, I would like to schedule a consultation regarding my legal matter.' :'Hujambo, ningependa kupanga mazungumzo kuhusu jambo langu la kisheria.');
    window.open(`https://wa.me/${contactDetails.whatsapp}?text=${message}`, '_blank');
  };

  const handleEmailClick = () => {
    const subject = encodeURIComponent(currentLanguage === 'en' ?'Legal Consultation Inquiry' :'Hoja ya Mazungumzo ya Kisheria');
    const body = encodeURIComponent(currentLanguage === 'en' ?'Dear Peter & Partners,\n\nI am writing to inquire about your legal services. Please contact me to discuss my legal matter.\n\nBest regards,' :'Waheshimiwa Peter & Partners,\n\nNaandika kuuliza kuhusu huduma zenu za kisheria. Tafadhali niwasiliane nami kujadili jambo langu la kisheria.\n\nHeshima zote,');
    window.open(`mailto:${contactDetails.email}?subject=${subject}&body=${body}`, '_self');
  };

  const contactMethods = [
    {
      icon: 'Phone',
      title: currentLanguage === 'en' ? 'Call Us' : 'Tupigie Simu',
      value: contactDetails.phone,
      description: currentLanguage === 'en' ? 'Immediate consultation available' : 'Mazungumzo ya haraka yapatikana',
      action: handlePhoneClick,
      buttonText: currentLanguage === 'en' ? 'Call Now' : 'Piga Simu Sasa',
      buttonVariant: 'outline'
    },
    {
      icon: 'MessageCircle',
      title: 'WhatsApp',
      value: contactDetails.phone,
      description: currentLanguage === 'en' ? 'Quick messaging and consultation' : 'Ujumbe wa haraka na mazungumzo',
      action: handleWhatsAppClick,
      buttonText: currentLanguage === 'en' ? 'Chat on WhatsApp' : 'Ongea WhatsApp',
      buttonVariant: 'primary'
    },
    {
      icon: 'Mail',
      title: currentLanguage === 'en' ? 'Email Us' : 'Tutumie Barua Pepe',
      value: contactDetails.email,
      description: currentLanguage === 'en' ? 'Detailed inquiries and documentation' : 'Maswali ya kina na nyaraka',
      action: handleEmailClick,
      buttonText: currentLanguage === 'en' ? 'Send Email' : 'Tuma Barua Pepe',
      buttonVariant: 'outline'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Contact Methods */}
      <div className="bg-white rounded-lg shadow-lg border border-border p-6 lg:p-8">
        <h3 className="text-xl font-semibold text-text-primary mb-6">
          {currentLanguage === 'en' ? 'Get in Touch' : 'Wasiliana Nasi'}
        </h3>
        
        <div className="space-y-6">
          {contactMethods.map((method, index) => (
            <div key={index} className="flex items-start space-x-4 p-4 rounded-lg hover:bg-surface/10 transition-colors duration-200">
              <div className="flex-shrink-0 w-12 h-12 bg-surface/20 rounded-lg flex items-center justify-center">
                <Icon name={method.icon} size={24} color="var(--color-primary)" />
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-text-primary mb-1">{method.title}</h4>
                <p className="text-primary font-medium mb-1">{method.value}</p>
                <p className="text-text-secondary text-sm mb-3">{method.description}</p>
                
                <Button
                  variant={method.buttonVariant}
                  onClick={method.action}
                  iconName={method.icon}
                  iconPosition="left"
                  size="sm"
                >
                  {method.buttonText}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Office Information */}
      <div className="bg-white rounded-lg shadow-lg border border-border p-6 lg:p-8">
        <h3 className="text-xl font-semibold text-text-primary mb-6">
          {currentLanguage === 'en' ? 'Office Information' : 'Taarifa za Ofisi'}
        </h3>
        
        <div className="space-y-6">
          {/* Address */}
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0 w-12 h-12 bg-surface/20 rounded-lg flex items-center justify-center">
              <Icon name="MapPin" size={24} color="var(--color-primary)" />
            </div>
            
            <div className="flex-1">
              <h4 className="font-medium text-text-primary mb-2">
                {currentLanguage === 'en' ? 'Office Address' : 'Anwani ya Ofisi'}
              </h4>
              <div className="text-text-secondary space-y-1">
                <p>{contactDetails.address.street}</p>
                <p>{contactDetails.address.area}</p>
                <p>{contactDetails.address.city}, {contactDetails.address.country}</p>
                <p>{currentLanguage === 'en' ? 'P.O. Box' : 'Sanduku la Posta'} {contactDetails.address.postalCode}</p>
              </div>
            </div>
          </div>

          {/* Business Hours */}
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0 w-12 h-12 bg-surface/20 rounded-lg flex items-center justify-center">
              <Icon name="Clock" size={24} color="var(--color-primary)" />
            </div>
            
            <div className="flex-1">
              <h4 className="font-medium text-text-primary mb-2">
                {currentLanguage === 'en' ? 'Business Hours' : 'Masaa ya Kazi'}
              </h4>
              <div className="text-text-secondary space-y-1">
                <div className="flex justify-between">
                  <span>{currentLanguage === 'en' ? 'Monday - Friday' : 'Jumatatu - Ijumaa'}</span>
                  <span>{contactDetails.businessHours.weekdays}</span>
                </div>
                <div className="flex justify-between">
                  <span>{currentLanguage === 'en' ? 'Saturday' : 'Jumamosi'}</span>
                  <span>{contactDetails.businessHours.saturday}</span>
                </div>
                <div className="flex justify-between">
                  <span>{currentLanguage === 'en' ? 'Sunday' : 'Jumapili'}</span>
                  <span>{currentLanguage === 'en' ? 'Closed' : 'Imefungwa'}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Emergency Contact */}
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0 w-12 h-12 bg-red-50 rounded-lg flex items-center justify-center">
              <Icon name="AlertTriangle" size={24} color="#EF4444" />
            </div>
            
            <div className="flex-1">
              <h4 className="font-medium text-text-primary mb-2">
                {currentLanguage === 'en' ? 'Emergency Contact' : 'Mawasiliano ya Dharura'}
              </h4>
              <p className="text-text-secondary text-sm">
                {currentLanguage === 'en' ?'For urgent legal matters outside business hours, please call our emergency line or send a WhatsApp message marked "URGENT".' : 'Kwa mambo ya haraka ya kisheria nje ya masaa ya kazi, tafadhali piga simu yetu ya dharura au tuma ujumbe wa WhatsApp ulioandikwa"DHARURA".'
                }
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;